<template>
  <div class="modal fade" id="customerSelectionModal" tabindex="-1" aria-labelledby="customerSelectionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="customerSelectionModalLabel">Select Customer</h5>
          <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Search input -->
          <div class="mb-3">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Search customers..."
                v-model="searchQuery"
                @input="filterCustomers"
              >
              <button class="btn btn-outline-secondary" type="button">
                <i class="bi bi-search"></i>
              </button>
            </div>
          </div>

          <!-- Customer list -->
          <div class="list-group">
            <button
              v-for="customer in filteredCustomers"
              :key="customer.id"
              class="list-group-item list-group-item-action"
              @click="selectCustomer(customer)"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="fw-bold">{{ customer.name }}</div>
                  <div class="small text-muted">{{ customer.email }}</div>
                </div>
                <span class="badge bg-primary rounded-pill">
                  {{ customerInteractionCount(customer.id) }}
                </span>
              </div>
            </button>
          </div>
          
          <!-- Empty state -->
          <div v-if="filteredCustomers.length === 0" class="text-center py-4">
            <i class="bi bi-search fs-1 text-muted"></i>
            <p class="mt-2 mb-0">No customers found</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'

export default {
  name: 'CustomerSelectionModal',
  emits: ['customer-selected'],
  
  setup(props, { emit }) {
    const store = useStore()
    const searchQuery = ref('')
    const modalInstance = ref(null)
    
    const customers = computed(() => store.state.customers)
    const interactions = computed(() => store.state.interactions)
    
    const filteredCustomers = computed(() => {
      if (!searchQuery.value) {
        return customers.value
      }
      
      const query = searchQuery.value.toLowerCase()
      return customers.value.filter(customer => 
        customer.name.toLowerCase().includes(query) ||
        customer.email.toLowerCase().includes(query) ||
        customer.phone?.toLowerCase().includes(query)
      )
    })
    
    const customerInteractionCount = (customerId) => {
      return interactions.value.filter(i => i.customerId === customerId).length
    }
    
    const filterCustomers = () => {
      // This is handled by the computed property, but kept for future enhancements
    }
    
    const selectCustomer = (customer) => {
      emit('customer-selected', customer)
      closeModal()
    }
    
    const showModal = () => {
      if (modalInstance.value) {
        modalInstance.value.show()
      }
    }
    
    const closeModal = () => {
      if (modalInstance.value) {
        modalInstance.value.hide()
      }
    }
    
    onMounted(() => {
      const modalEl = document.getElementById('customerSelectionModal')
      if (modalEl) {
        modalInstance.value = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        })
      }
    })
    
    return {
      searchQuery,
      filteredCustomers,
      customerInteractionCount,
      filterCustomers,
      selectCustomer,
      showModal,
      closeModal
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 95%;
  margin: 10px auto;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
  }
}
</style>
